import React from 'react'
import { useTranslation } from 'react-i18next'

import translations from '@translationKeys'

import { CustomTooltip } from '@components/CustomTooltip'
import LockIcon from '@mui/icons-material/Lock'

import { PrivateCompanyIndicatorWrapper } from './index.styles'

export const PrivateCompanyIndicator = () => {
  const { t } = useTranslation()

  return (
    <PrivateCompanyIndicatorWrapper>
      <CustomTooltip title={t(translations.PRIVATE_COMPANY_INDICATOR_TEXT)} placement="top">
        <LockIcon color="primary" fontSize="small" />
      </CustomTooltip>
    </PrivateCompanyIndicatorWrapper>
  )
}
